import { gql } from 'react-apollo';

export default gql`
  mutation submitComment($input: CommentInput!) {
    submitComment(input: $input) {
      _id

      content
      title
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/submitComment.js